"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _tokenClass = _interopRequireDefault(require("./tokenClass"));

var _tokens = _interopRequireDefault(require("./tokens"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var ServiceClass = /*#__PURE__*/function () {
  function ServiceClass() {
    _classCallCheck(this, ServiceClass);
  }

  _createClass(ServiceClass, null, [{
    key: "getConfig",
    value: function () {
      var _getConfig = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var path, config;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                path = process.env.PUBLIC_URL + "/config.json";
                _context.next = 3;
                return fetch(path);

              case 3:
                config = _context.sent;
                _context.next = 6;
                return config.json();

              case 6:
                config = _context.sent;
                return _context.abrupt("return", config);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function getConfig() {
        return _getConfig.apply(this, arguments);
      }

      return getConfig;
    }()
    /**
     * @description Ritorna il codice dell'azienda letto dal file di configurazione
     */

  }, {
    key: "getAziendaId",
    value: function () {
      var _getAziendaId = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var config;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return ServiceClass.getConfig();

              case 2:
                config = _context2.sent;
                return _context2.abrupt("return", config["aziendaId"]);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function getAziendaId() {
        return _getAziendaId.apply(this, arguments);
      }

      return getAziendaId;
    }()
    /**
     * @description Ritorna il codice dell'applicativo letto dal file di configurazione
     */

  }, {
    key: "getApplicationCode",
    value: function () {
      var _getApplicationCode = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var config;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return ServiceClass.getConfig();

              case 2:
                config = _context3.sent;
                return _context3.abrupt("return", config["codiceApplicazione"]);

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function getApplicationCode() {
        return _getApplicationCode.apply(this, arguments);
      }

      return getApplicationCode;
    }()
    /**
     * @description Ritorna il copyright
     */

  }, {
    key: "getCopyright",
    value: function () {
      var _getCopyright = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var config;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return ServiceClass.getConfig();

              case 2:
                config = _context4.sent;
                return _context4.abrupt("return", config["copyright"]);

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function getCopyright() {
        return _getCopyright.apply(this, arguments);
      }

      return getCopyright;
    }()
    /**
     * @description Ritorna l'url di default
     */

  }, {
    key: "getHomePageLink",
    value: function () {
      var _getHomePageLink = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var config;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return ServiceClass.getConfig();

              case 2:
                config = _context5.sent;
                return _context5.abrupt("return", config["homePage"]);

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function getHomePageLink() {
        return _getHomePageLink.apply(this, arguments);
      }

      return getHomePageLink;
    }()
    /**
    * @description Metodo per la chiamata al web service. Passare l'url e i dati all'interno del parametro data.    
    * @param {string} url 
    * @param {object} data    
    */

  }, {
    key: "postData",
    value: function () {
      var _postData = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var url,
            data,
            config,
            response,
            _args6 = arguments;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                url = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : '';
                data = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : {};
                _context6.prev = 2;
                _context6.next = 5;
                return ServiceClass.getConfig();

              case 5:
                config = _context6.sent;
                _context6.next = 8;
                return ServiceClass.generateToken();

              case 8:
                data["token"] = _context6.sent;
                _context6.next = 11;
                return fetch(config.webService + url, {
                  method: 'POST',
                  mode: 'cors',
                  cache: 'no-cache',
                  credentials: 'same-origin',
                  headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                  },
                  redirect: 'follow',
                  referrerPolicy: 'no-referrer',
                  body: JSON.stringify(data)
                });

              case 11:
                response = _context6.sent;
                return _context6.abrupt("return", response.json());

              case 15:
                _context6.prev = 15;
                _context6.t0 = _context6["catch"](2);
                console.log(_context6.t0);

              case 18:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, null, [[2, 15]]);
      }));

      function postData() {
        return _postData.apply(this, arguments);
      }

      return postData;
    }()
  }, {
    key: "getWebServiceUrl",
    value: function () {
      var _getWebServiceUrl = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var config;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                _context7.next = 3;
                return ServiceClass.getConfig();

              case 3:
                config = _context7.sent;
                return _context7.abrupt("return", config.webService);

              case 7:
                _context7.prev = 7;
                _context7.t0 = _context7["catch"](0);
                console.log(_context7.t0);

              case 10:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, null, [[0, 7]]);
      }));

      function getWebServiceUrl() {
        return _getWebServiceUrl.apply(this, arguments);
      }

      return getWebServiceUrl;
    }()
    /**
     * @description Metodo per la generazione del token
     * Se il token è già in sessione utilizza quello per generare un nuovo token con quello già creato, in caso
     * contrario ne genera un altro passando il solo codice APPLICATIVO. Gli altri campi (permessi, odbc, ambito, utente) vengono compilati dal servizio
     */

  }, {
    key: "generateToken",
    value: function () {
      var _generateToken = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var token, tokenKey, generatedToken;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;
                token = new _tokens.default();
                tokenKey = localStorage.getItem("tokenKey");
                generatedToken = "";

                if (!(tokenKey != null && tokenKey !== "")) {
                  _context8.next = 8;
                  break;
                }

                generatedToken = token.generateTokenFromEncrypted(tokenKey);
                _context8.next = 15;
                break;

              case 8:
                _context8.t0 = token;
                _context8.t1 = _tokenClass.default;
                _context8.next = 12;
                return ServiceClass.getApplicationCode();

              case 12:
                _context8.t2 = _context8.sent;
                _context8.t3 = new _context8.t1(_context8.t2);
                generatedToken = _context8.t0.generateTokenFromPlain.call(_context8.t0, _context8.t3);

              case 15:
                if (!(generatedToken !== undefined && generatedToken !== "" && generatedToken["data"] !== undefined)) {
                  _context8.next = 17;
                  break;
                }

                return _context8.abrupt("return", generatedToken["data"]);

              case 17:
                _context8.next = 21;
                break;

              case 19:
                _context8.prev = 19;
                _context8.t4 = _context8["catch"](0);

              case 21:
                return _context8.abrupt("return", "");

              case 22:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, null, [[0, 19]]);
      }));

      function generateToken() {
        return _generateToken.apply(this, arguments);
      }

      return generateToken;
    }()
  }, {
    key: "generateTokenWithLogin",
    value: function generateTokenWithLogin() {
      try {
        var token = new _tokens.default();
        var tokenKey = localStorage.getItem("tokenKey");
        var applicationCode = localStorage.getItem("applicationCode");
        var generatedToken = "";

        if (tokenKey != null && tokenKey !== "") {
          generatedToken = token.generateTokenFromEncrypted(tokenKey);
        } else {
          generatedToken = token.generateTokenFromPlain(new _tokenClass.default(applicationCode));
        }

        if (generatedToken !== undefined && generatedToken !== "" && generatedToken["data"] !== undefined) {
          return generatedToken["data"];
        }
      } catch (e) {}

      return "";
    }
  }]);

  return ServiceClass;
}();

var _default = ServiceClass;
exports.default = _default;